import { makeHeadingPropsSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { getCompositeSettingSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { type PackagePricing } from "../types";
import Component, { type Props } from "./component";

const makeMapStateToProps = () => {
  const sliderSettingsSelector = getCompositeSettingSelector<PackagePricing.Settings.Slider>(
    TargetSelector.Entity,
    "sliders"
  );
  const headingPropsSelector = makeHeadingPropsSelector(TargetSelector.Entity, "sliders");

  return (state: AppState, props: Omit<Props, "headingProps" | "settings">): Props => {
    return {
      ...props,
      headingProps: headingPropsSelector(state, props),
      settings: sliderSettingsSelector(state, props)!
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
